import { render, staticRenderFns } from "./notice-item.vue?vue&type=template&id=6559e6b1&scoped=true"
import script from "./notice-item.vue?vue&type=script&lang=js"
export * from "./notice-item.vue?vue&type=script&lang=js"
import style0 from "./notice-item.vue?vue&type=style&index=0&id=6559e6b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6559e6b1",
  null
  
)

export default component.exports